import { render, staticRenderFns } from "./CatalogSourceListReplace.vue?vue&type=template&id=6894bd12"
import script from "./CatalogSourceListReplace.vue?vue&type=script&lang=ts"
export * from "./CatalogSourceListReplace.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSourceListReplace.vue?vue&type=style&index=0&id=6894bd12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports